import ACTION_ITEMS from '../../../actionItems';

export const setPsychQuestion = (question) => (dispatch) => {
  dispatch({
    type: ACTION_ITEMS.PSYCHOMETRIC.QUESTION.SET,
    payload: question,
  });
};
